import { ApiCacheTags, baseApiService } from '@qapline/api';
import { config } from 'config';
import { Countries } from 'modules/common';
import { TGetGeoCodedAddressResponse } from 'types/api';

type TExchangeRateResponse = { base: string; target: string; rate: number };
type TExchangeRateArgs = { date?: string | null } | void;

export const appApi = baseApiService.injectEndpoints({
    endpoints: (builder) => ({
        getCompanyData: builder.query<
            {
                ico: string;
                dic: string;
                name: string;
                address: {
                    street: string;
                    city: string;
                    houseNumber: string;
                    zip: number;
                    country: keyof typeof Countries;
                };
            },
            { companyRegistrationNumber: number }
        >({
            providesTags: [ApiCacheTags.ares.companies],
            query: ({ companyRegistrationNumber }) => ({
                url: config.api.endpoints.ares,
                method: 'GET',
                params: { ico: String(companyRegistrationNumber).padStart(8, '0') },
            }),
        }),
        getExchangeRate: builder.query<TExchangeRateResponse, TExchangeRateArgs>({
            query: (args) => ({
                url: config.api.endpoints.rate,
                method: 'GET',
                params: { currency: 'EUR', ...(args?.date ? { date: args.date } : {}) },
            }),
        }),
        getGeoCodedAddress: builder.query<TGetGeoCodedAddressResponse, string>({
            query: (searchTerm) => ({
                url: config.api.endpoints.geocoding.forward,
                method: 'GET',
                params: {
                    search: searchTerm,
                },
            }),
        }),
    }),
});

export const {
    useLazyGetCompanyDataQuery,
    useLazyGetExchangeRateQuery,
    useLazyGetGeoCodedAddressQuery,
    useGetGeoCodedAddressQuery,
} = appApi;
